<!-- 首页 -->
<template>
  <!-- <div class="index-container"> -->
  <div class="index">
    <div class="background"></div>
    <Header></Header>
    <div class="main">
      <el-row class="middle">
        <el-col class="middleRight">
          <el-row type="flex" justify="center">
            <el-col :xs="0" :sm="0" :md="2" :lg="2" :xl="2"></el-col>

            <!-- <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" style="background-color: red;"></el-col> -->
            <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">

              <div class="rightArea">
                <el-row type="flex" justify="center">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="intrArea">
                      <div class="area-title">
                        <h3>待定</h3>
                      </div>
                      <!-- <p><b>围绕</b>危险化学物质快速准确的检测鉴定与精准识别，<b>针对潜在的和现实的化学安全威胁</b>，
                        为部队或应急管理、公安部、科技部等相关部门的防控化学武器扩散、防反化学恐怖袭击、防控重大化学事故、
                        防止化学品和化学技术谬用、保护化学设施和化学资源安全、保障国家重大活动等工作提供技术支撑。
                      </p> -->
                      <!-- <router-link :to="{path:'/intr'}">>>详细内容</router-link> -->
                    </div>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center" class="middle" style="margin-bottom: 2vw;">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="middleRight">
                    <el-row type="flex" justify="center">
                      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">

                        <div class="newsArea-box">
                          <el-row type="flex" justify="center">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                              <div class="newsArea">
                                <div class="area-title">
                                  <h3>新闻动态</h3>
                                </div>
                                <div class="news" v-for="(e,index) in newslist"
                                :key="index"
                                style="
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;
                                "
                                >
                                  <router-link :to="{path:'/newsdetail',query:{id:e.id}}">{{e.title}}</router-link>
                                  <!-- <p>{{e.intr.slice(0,36)}}......</p> -->
                                  <p>{{e.intr}}</p>
                                </div>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                      </el-col>



                    </el-row>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="shareArea">
                      <div class="area-title">
                        <h3>待定</h3>
                      </div>
                      <!-- <h4>交流动态</h4> -->

                      <div class="items" v-for="(e,index) in dynamicList" :key="index" v-if="dynamicList.length!=0">
                        <router-link :to="{path:'/dynamicdetail',query:{id:e.id}}">{{e.title}}</router-link>
                        <!-- <p>{{e.intr.slice(0,36)}}......</p> -->
                        <p>{{e.intr}}</p>
                      </div>

                      <ul class="dynamic" v-if="dynamicList.length==0">
                        To Be Announced...
                      </ul>
                    </div>
                  </el-col>
                </el-row>


              </div>

            </el-col>
            <el-col :xs="0" :sm="0" :md="2" :lg="2" :xl="2"></el-col>
          </el-row>



        </el-col>
      </el-row>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import Scatter from '../components/Scatter.vue'
  export default {
    data() {
      return {
        // showPoster: false,
        newslist: '',
        dynamicList: '',

      };
    },

    components: {
      Scatter
    },

    mounted() {
      //  let that=this;
      //  var timer= setTimeout(function(){
      //     that.showPoster=false;
      //   },5000);
      // window.clearTimeout(timer);

      // this.$axios.get('http://www.csaln.cn/api/newslist', {
      //   params: {
      //     page: this.page
      //   }
      // }).then(res => {
      //   this.newslist = res.data.newslist.slice(0, 2);
      // })

      this.getDynamicList()
      this.getNewList()

    },

    beforeDestroy() {
      // clearTimeout(timer);
      // this.showPoster=false;
      // console.log(this.showPoster);
    },

    methods: {
      getNewList() {
        this.instance.get('/api/newslist').then(res => {
          this.newslist = res.data.newslist.slice(0,3);
        })
      },


      getDynamicList() {
        this.instance.get('/api/dynamic/dynamiclist').then(res => {
          if (res.status == 200) {
            // this.dynamicList = res.data.dynamiclist
            this.dynamicList = res.data.dynamiclist.slice(0, 5);
          }
        })
      },
    }
  }
</script>
<style scoped>
  /* 通用标签 */


  /* 右侧其他内容 */
  /* 各个div内的主标题 */
  /* .index-container .mapArea>h3,
  .index-container .main-right h3 */
  /* .index .mapArea h3,
  .index .main-right h3 {
    height: 2vw;
    color: #3C4A5D;
    line-height: 2vw;
    text-align: center;
    border-bottom: 0.1vw solid #B2B2B2;
    font-size: 1.1vw;
    font-size: 1.1vw;
  } */

  .index .area-title {
    text-align: center;
    padding-top: 0.5vw;
    padding-bottom: 0.5vw;
    border-bottom: 0.1vw solid #B2B2B2;
  }

  .area-title h3 {
    font-size: 1.1vw;
  }


  /* 海报层 */
  .poster {
    width: 100%;
    margin: 1vw 0;
  }

  .poster>img {
    width: 100%;
    height: auto;
  }

  /* .index {
    width: 100%;
    height: 100%;
    position: fixed;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-image: url(../assets/img/index/background.png);
  } */

  /* main */
  .index-container {
    width: 1600px;
    margin: auto;
    overflow: hidden;
    position: relative;
  }

  .index::before {
    content: '';
    display: table;
  }

  /* 左侧地图 */
  .mapArea {
    /* float: left; */
    /* width: 100%; */
    width: 96%;
    margin-left: 2%;
    margin-right: 2%;
    /* width: 860px; */
    /* height: 100%; */
    height: 36vw;
    /* margin-bottom: 40px; */
    margin-bottom: 2vw;
    position: relative;
    /* background-color: rgba(255, 255, 255, 0.9); */
    /* border: 1px solid yellowgreen; */
    /* background: hsla(0, 0%, 100%, .2); */
    background: rgba(255, 255, 255, 0.95);
    border: 0.1vw solid rgb(60, 74, 93, .2);
    /* border-radius: 0.9375rem; */
    box-shadow: 0 0.3vw 0.4vw rgba(0, 0, 0, .12), 0 0 0.6vw rgba(0, 0, 0, .04);
  }


  /* 地图星星定位 */
  .mapArea>img {
    position: absolute;
    width: 15px;
    height: 15px;
    pointer-events: none;
  }

  .mapArea>.beijign {
    right: 288px;
    top: 303px;
  }

  .mapArea>.guangzhou {
    right: 320px;
    bottom: 100px;
  }

  .mapArea>.xinjiang {
    left: 245px;
    top: 260px;
  }

  .mapArea>.xiamen {
    right: 270px;
    bottom: 126px;
  }

  .mapArea>.nanjing {
    right: 255px;
    top: 425px;
  }

  .mapArea>.harbin {
    right: 170px;
    top: 215px;
  }

  .mapArea>.tianjin {
    right: 276px;
    top: 315px;
  }

  .mapArea>.markimg {
    top: 142px;
    right: 194px;
    width: 20px;
    height: 28px;
  }

  /* 右侧内容 */
  .rightArea {
    /* float: right; */
    /* width: 680px; */
    /* border: 1px solid purple; */
    /* background-color: #6495ED; */
    /* height: 36vw; */
    height: auto;
    width: 96%;
    margin-left: 2%;
    margin-right: 2%;
  }



  /* 简介 */
  .intrArea {
    position: relative;
    /* margin-bottom: 40px; */
    margin-bottom: 2vw;
    padding: 0 1vw;
    height: 11vw;
    /* background-color: rgba(255, 255, 255, 0.9); */
    /* background: hsla(0, 0%, 100%, .3); */
    background: rgba(255, 255, 255, 0.95);
    border: 0.0625rem solid rgb(60, 74, 93, .2);
    /* border-radius: 0.9375rem; */
    box-shadow: 0 0.3vw 0.4vw rgba(0, 0, 0, .12), 0 0 0.6vw rgba(0, 0, 0, .04);
    overflow: auto;
    border-radius: 0.5vw;
  }

  .intrArea>p {
    text-align: justify;
    padding: 1vw 1vw 0 1vw;
    font-size: 0.9vw;
  }

  .intrArea>a {
    color: #3C4A5D;
    /* padding: 10px 20px; */
    padding: 0.5vw 1vw;
    /* font-size: 14px; */
    font-size: 0.8vw;
    font-weight: bold;
    display: block;
  }

  /* 新闻 */
  .news-join {
    width: 48%;
    float: left;
  }

  .newsArea-box {
    /* background-color: rosybrown; */
    /* height: 16vw; */
    /* height: auto; */
  }

  .newsArea {
    position: relative;
    padding: 0 1vw 0.5vw 1vw;
    /* height: 16vw; */
    min-height: 16vw;
    height: auto;
    /* background-color: rgba(255, 255, 255, 0.9); */
    /* border: 1px solid red; */
    /* background: hsla(0, 0%, 100%, .2); */
    background: rgba(255, 255, 255, 0.95);
    border: 0.0625rem solid rgb(60, 74, 93, .2);
    /* border-radius: 0.9375rem; */
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, .12), 0 0 0.75rem rgba(0, 0, 0, .04);
    overflow: auto;
    border-radius: 0.5vw;
  }

  /*滚动条样式*/
  /* .newsArea::-webkit-scrollbar,
  .shareArea::-webkit-scrollbar
  {
    width: 0.2vw;
  }

  .newsArea::-webkit-scrollbar-thumb,
  .shareArea::-webkit-scrollbar
  {
    border-radius: 0.625rem;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .newsArea::-webkit-scrollbar-track,
  .shareArea::-webkit-scrollbar{
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  } */
  .news{
    margin-bottom: 1vw;
  }


  .newsArea>.news {
    padding: 0.5vw 0.5vw;
    /* height: 118px; */
    /* height: 6.6vw; */
  }

  .newsArea>.news>a {
    color: #000000;
    font-weight: bold;
    /* font-size: 14px; */
    font-size: 1vw;
    text-decoration: underline;
  }

  .newsArea>.news>p {
    text-indent: 1.8vw;
    /* font-size: 14px; */
    font-size: 0.9vw;
    text-align: justify;
    margin-top: 0.4vw;
  }

  .joinArea {
    /* opacity: 0.8; */
    text-align: center;
    margin-top: 2vw;
    height: 5vw;
    /* margin: 1.5vw 0 0 0; */
    /* padding: 1.5vw 0; */
    border-radius: 0.9375rem;
    /* background-color: #333F50; */
    /* background: hsla(215, 36%, 31%, .8); */
    /* background: linear-gradient(45deg, rgba(0,202,229,0.5), rgba(0,15,92,0.5)); */
    background: linear-gradient(45deg, rgba(0, 222, 229, 0.3), rgba(0, 150, 229, 0.5));
    /* border: 0.0625rem solid rgb(60, 74, 93, .2); */
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, .12), 0 0 0.75rem rgba(0, 0, 0, .04)
  }

  /* .joinArea>img {
    width: 2vw;
    height: 3vw;
    vertical-align: middle;
  } */

  /* .joinArea>a>div {
    color: #FFFFFF;
    font-size: 1vw;
    display: inline-block;
    letter-spacing: 0.3vw;
    font-weight: bold;
    margin-bottom: 1vw;
    margin-left: 1vw;
  } */

  .welcom-box {
    height: 3vw;
    /* background-color: #F6BB00; */
    position: relative;
    top: 1vw;
  }

  .welcome-img {
    position: absolute;
    left: 50%;
    margin-left: -4vw;
    height: 100%;
  }

  .welcome-text {
    position: absolute;
    left: 50%;
    margin-left: -0.5vw;
    top: 50%;
    margin-top: -0.6vw;
    /* background-color: #000000; */
    display: inline-block;
    color: #FFFFFF;
    font-size: 1vw;
    letter-spacing: 0.3vw;
    font-weight: bold;
  }



  /* 交流共享 */
  .shareArea {
    /* width: 48%; */
    width: 100%;
    height: 23vw;
    /* height: 450px; */
    /* height: 23.5vw; */
    float: right;
    position: relative;
    padding: 0 1vw 1vw 1vw;
    /* background-color: rgba(255, 255, 255, 0.9); */
    /* border: 1px solid pink; */
    /* background: hsla(0, 0%, 100%, .2); */
    background: rgba(255, 255, 255, 0.95);
    border: 0.0625rem solid rgb(60, 74, 93, .2);
    /* border-radius: 0.9375rem; */
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, .12), 0 0 0.75rem rgba(0, 0, 0, .04);
    overflow: auto;
  }

  .shareArea>h4 {
    text-align: center;
    font-size: 0.9vw;
    padding: 0.5vw 0;
  }

  .shareArea>.items {
    padding: 0.5vw 0.5vw;
    /* height: 118px; */
    /* height: 6.6vw; */
  }

  .shareArea>.items>a {
    color: #000000;
    font-weight: bold;
    /* font-size: 14px; */
    font-size: 0.75vw;
    text-decoration: underline;
  }

  .shareArea>.items>p {
    text-indent: 2rem;
    /* font-size: 14px; */
    font-size: 0.75vw;
    text-align: justify;
    margin-top: 0.5vw;
  }

  .dynamic {
    /* height: 25vw; */
    height: 50%;
    list-style: none;
    /* padding: 0 0.5vw; */
    /* border: 1px solid red; */
    /* background-color: #2C90FF; */
  }

  .dynamic-item>a {
    font-size: 14px;
    color: #000000;
    border-bottom: 0.1vw solid #000000;
  }


  .otherArea {
    padding-top: 0.8vw;
    border-top: 0.1vw solid #B2B2B2;
    /* border: 1px solid blue; */
  }

  .otherArea>ul {
    display: flex;
    list-style: none;
    justify-content: space-between;
  }

  .otherArea>ul>li {
    display: inline-block;
    /* margin: 10px 20px 5px 0; */
    /* height: 1.5vw; */
    /* line-height: 1.5vw; */
    /* height: 8vw;
    line-height: 8vw; */
    /* border: 1px solid red; */
  }

  .otherArea>ul>li>a {
    color: #000000;
    font-weight: bold;
    font-size: 0.8vw;
    border-bottom: 0.1vw solid #767676;
  }

  .others {
    width: 100%;
    margin-top: 0.6vw;
    text-align: center;
  }


  .others>.others-box-item:nth-child(1) {
    /* margin-right: 2vw; */
    float: left;
  }

  .others>.others-box-item:nth-child(3) {
    /* margin-left: 2vw; */
    float: right;
  }


  .others-box-item,
  .others-box-item-alone {
    display: inline-block;
  }

  .others-box-item>a {
    font-weight: bold;
    font-size: 0.8vw;
    color: #000000;
    border-bottom: 0.1vw solid #767676;
  }

  .others-box-item>a:hover {
    color: #FFC000;
    border-bottom: 0.1vw solid #FFC000;
  }

  .others-box-item>a:active {
    color: #FFC000;
  }


  /* 各个区域的毛玻璃效果 */
  .mapArea::before,
  .intrArea::before,
  .newsArea::before,
  .shareArea::before,
  .joinArea::before {
    /* filter: blur(6px);
    z-index:-2; */
    content: '';
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* filter: blur(0.4vw); */
    position: absolute;
    /* background-size: cover; */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: top center;
    /* background-image: url(../assets/img/index/background.png); */
    /* background-color: white; */
    background-attachment: fixed;
  }

  /* 滚动条样式 */
  .newsArea::-webkit-scrollbar,
  .shareArea::-webkit-scrollbar {
    width: 0.4vw;
  }

  .newsArea::-webkit-scrollbar-track,
  .shareArea::-webkit-scrollbar-track {
    /* background-color: rgba(255, 79, 77, 0.1); */
    background-color: rgba(255, 255, 255, 0.1);
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }

  .newsArea::-webkit-scrollbar-thumb,
  .shareArea::-webkit-scrollbar-thumb {
    /* background-color: rgba(255, 79, 77, 0.5); */
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
  }

  /* .mapArea::after,
  .intrArea::after,
  .newsArea::after,
  .shareArea::after {
    content: '';
    z-index: -5;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    filter: blur(6px);
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    background-image: url(../assets/img/index/background.png);
    background-attachment: fixed;
  } */

  /* 一级缩略 */
  @media screen and (max-width:1200px) {
    .area-title h3 {
      font-size: 2.5vw;
    }

    /* 简介 */
    .intrArea {
      height: 23vw;
    }

    .intrArea>p {
      font-size: 2vw;
    }

    .intrArea>a {
      font-size: 2vw;
    }

    /* 加入 */
    .joinArea-box {
      display: none;
    }

    /* 新闻 */
    /* .newsArea-box {
      height: 23vw;
    } */

    .newsArea {
      height: 23vw;
    }

    .newsArea>.news>a {
      font-size: 2vw;
    }

    .newsArea>.news>p {
      font-size: 2vw;
    }

    /* 分享 */
    .shareArea {
      margin-top: 2vw;
      height: 48vw;
    }

    .shareArea>h4 {
      font-size: 1.8vw;
    }


    .others {
      margin-top: 2vw;
    }

    .others-box-item>a {
      font-size: 1.8vw;
    }

    /* .poster {
      margin-bottom: 8vw;
    } */
  }

  /* 二级缩略 */
  @media screen and (max-width:768px) {
    .area-title h3 {
      font-size: 3vw;
    }

    .mapArea {
      display: none;
    }

    .intrArea {
      height: 30vw;
    }

    .intrArea>p {
      font-size: 2.5vw;
      line-height: 4.5vw
    }

    .intrArea>a {
      font-size: 2.5vw;
    }

    /* 新闻 */
    /* .newsArea-box {
      height: 30vw;
    } */

    .newsArea {
      /* height: 30vw; */
    }

    .newsArea>.news {
      margin-top: 1.5vw;
    }

    .newsArea>.news>a {
      font-size: 2.5vw;
    }

    .newsArea>.news>p {
      font-size: 2.5vw;
    }

    /* 分享 */
    .shareArea {
      margin-top: 2vw;
      height: 57vw;
    }

    .shareArea>h4 {
      font-size: 2.5vw;
    }

    .others {
      margin-top: 1.5vw;
    }

    .others-box-item>a {
      font-size: 2.1vw;
    }

    /* .poster {
      margin-bottom: 10vw;
    } */

  }

  /* 三级缩略 */
  @media screen and (max-width:500px) {
    .area-title h3 {
      font-size: 5vw;
    }

    .intrArea {
      height: 60vw;
      border-radius: 0;
      margin-bottom: 8vw;
    }

    .intrArea>p {
      font-size: 4.2vw;
      line-height: 6vw
    }

    .intrArea>a {
      font-size: 4vw;
    }

    /* 新闻 */
    /* .newsArea-box {
      height: 70vw;
    } */

    .newsArea {
      height: auto;
      /* border-radius: 0; */
    }

    .newsArea>.news {
      margin-top: 4vw;
    }

    .newsArea>.news>a {
      font-size: 4.2vw;
    }

    .newsArea>.news>p {
      font-size: 4.2vw;
    }

    /* 分享 */
    .shareArea {
      margin-top: 8vw;
      margin-bottom: 8vw;
      height: 85vw;
      border-radius: 0;
    }

    .shareArea>h4 {
      font-size: 4.2vw;
    }

    .others {
      margin-top: 1.5vw;
    }

    .others-box-item>a {
      font-size: 4vw;
    }

    /* .poster {
      margin-bottom: 14vw;
    } */
  }
</style>



// WEBPACK FOOTER //
// src/views/Index.vue